import { errorBox } from '@core/components/AlertBox';
import { environment } from '@core/environment';
import { buildConMonLink, convertThreeViewportToMapbox } from '@core/logic';
import { OpenInNew } from '@mui/icons-material';
import { Button } from '@mui/material';
import { viewer3dSelectors } from '@viewer3D/redux';
import { useSelector } from 'react-redux';

export const ConmonLink = () => {
  const cameraViewport = useSelector(viewer3dSelectors.cameraViewport);
  const { isDev } = environment;

  const handleClick = () => {
    const { zoom, lat, lon } = convertThreeViewportToMapbox(cameraViewport);
    if (!zoom || !lat || !lon) {
      errorBox('Location URL can not be generated. At least one scan must be loaded on the map.');
      return;
    } else {
      window.open(buildConMonLink(zoom, lat, lon, isDev), '_blank');
    }
  };

  return (
    <Button startIcon={<OpenInNew />} onClick={handleClick}>
      View in ConMon
    </Button>
  );
};
